module.exports = __webpack_public_path__ + "assets/img/is-top.5dcef7b6.svg";